import { useContext } from "react";
import BaseActions, { APIRequestGenerator } from "base/BaseActions";
import APIHelper from "base/APIHelper";
import BaseModel from "base/BaseModel";
import UserModel from "./userModel";

const module = "blacklist";

const useBlacklistModel = () => {
  const { token, Organization } = useContext(UserModel.Context);

  const { getList, createOne } = BaseActions(module, {
    token,
    Organization,
  });

  async function removeFromBlacklist(id, data) {
    const { url, headers } = APIRequestGenerator(
      `${process.env.REACT_APP_HOST}/${module}/${id}/remove`,
      null,
      token,
    );
    try {
      const response = await APIHelper(
        "PUT",
        url.toString(),
        data,
        true,
        headers,
      );

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  return {
    getList,
    createOne,
    removeFromBlacklist,
  };
};

const BlacklistModel = BaseModel(useBlacklistModel, "BlacklistModel");

export { useBlacklistModel };
export default BlacklistModel;
